import { render, staticRenderFns } from "./RemindersModal.vue?vue&type=template&id=f75a011e&scoped=true&"
import script from "./RemindersModal.vue?vue&type=script&lang=js&"
export * from "./RemindersModal.vue?vue&type=script&lang=js&"
import style0 from "./RemindersModal.vue?vue&type=style&index=0&id=f75a011e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75a011e",
  null
  
)

component.options.__file = "RemindersModal.vue"
export default component.exports